// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11snP","icon":"styles_icon__2Mai1"};